<template>
  <Loader v-if="loading"> </Loader>
  <div>
    <div class="center-content">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="history-header">Upload File RCU</h1>
          <div class="flex align-items-center flex-column">
            <div class="dropdown-wrapper mb-2">
              <label for="destination">Seleziona Destinazione:</label>
              <select v-model="selectedDestination" id="destination" class="custom-dropdown">
                <option v-for="path in paths" :key="path" :value="path">
                  {{ path }}
                </option>
              </select>
            </div>
            <div class="button-wrapper mb-2">
              <span class="label">{{
                fileToUpload.length == 0
                  ? "Seleziona File"
                  : fileToUpload.length + " files"
              }}</span>
              <input id="upload" type="file" ref="file" @change="handleFileUpload($event)"
                accept="application/zip,application/x-zip-compressed" multiple />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">
              Campo richiesto.
            </div>
            <div v-show="validationErrors.type && submitted" class="p-error">
              Formato non consentito
            </div>
          </div>
          <div class="text-center">
            <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
          </div>
          <Button @click="uploadFileRcuOnFtpAndDB" label="Carica File" class="upload-button" />
        </template>
      </Card>
    </div>

    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br />
          <h3 class="history-header">Storico File Caricati</h3>
        </template>
        <template v-slot:content>
          <div>
            <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input" />
          </div>
          <DataTable :value="paginatedFiles" responsiveLayout="scroll" class='file-table'>
            <Column field="file_name" header="Nome File"></Column>
            <Column field="created_at" header="Data Caricamento"></Column>
          </DataTable>
          <div class="file-count-select-wrapper">
            <select id="fileCount" v-model="filesPerPage" class="file-count-select">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </template>
      </Card>
    </div>

    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br />
          <h3 class="history-header">Upload File RCU Dati Energia</h3>
        </template>
        <template v-slot:content>
          <div class="flex align-items-center flex-column">
            <div class="dropdown-wrapper mb-2">
              <label for="destinationEnergy">Seleziona Destinazione:</label>
              <select v-model="selectedEnergyDestination" id="destinationEnergy" class="custom-dropdown">
                <option v-for="path in energyPaths" :key="path" :value="path">
                  {{ path }}
                </option>
              </select>
            </div>
            <div class="button-wrapper mb-2">
              <span class="label">{{
                energyFileToUpload.length == 0
                  ? "Seleziona File"
                  : energyFileToUpload.length + " files"
              }}</span>
              <input id="uploadEnergy" type="file" ref="energyFile" @change="handleEnergyFileUpload($event)"
                accept="application/zip,application/x-zip-compressed" multiple />
            </div>
            <div v-show="energyValidationErrors.files && energySubmitted" class="p-error">
              Campo richiesto.
            </div>
            <div v-show="energyValidationErrors.type && energySubmitted" class="p-error">
              Formato non consentito
            </div>
            <div class="text-center mt-3">
              <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
            </div>
            <Button @click="uploadEnergyFileRcu" label="Carica File" class="upload-button" />
            <div class="mt-4 import-section">
              <h3 class="history-header">Importa Dati Su Ask</h3>
              <div class="date-selector-container mb-3">
                <div class="date-selector-row">
                  <label for="monthYear">Seleziona Mese/Anno:</label>
                  <Calendar v-model="selectedDate" view="month" dateFormat="mm/yy" :showIcon="true"
                    :showButtonBar="false" class="custom-calendar" panelClass="month-picker-panel" />
                </div>
              </div>
              <div class="import-buttons">
                <Button @click="importRcuGasData" label="Importa Rcu Dati Gas" :disabled="!selectedDate" class="mr-2" />
                <Button @click="importRcuEEData" label="Importa Rcu Dati EE" :disabled="!selectedDate" />
              </div>
            </div>
          </div>

          <div class="import-status-section mt-4">
            <div v-if="importStatus && importStatus.data" class="status-tables">

              <div class="status-table-container">
                <h5>RCU Gas</h5>
                <table class="file-table">
                  <thead>
                    <tr>
                      <th>Mese</th>
                      <th>Da Importare</th>
                      <th>Importati</th>
                      <th>Totale Files</th>
                    </tr>
                  </thead>
                  <tbody v-if="importStatus.data.gas.months.length > 0">
                    <template v-for="monthData in importStatus.data.gas.months" :key="monthData.month">

                      <tr class="month-row" @click="toggleMonth('gas', monthData.month)">
                        <td>
                          <i
                            :class="['fas', expandedMonths[`gas-${monthData.month}`] ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
                          {{ monthData.month }}
                        </td>
                        <td>{{ monthData.to_import.length }}</td>
                        <td>{{ monthData.imported.length }}</td>
                        <td>{{ monthData.to_import.length + monthData.imported.length }}</td>
                      </tr>

                      <tr v-if="expandedMonths[`gas-${monthData.month}`]" class="detail-row">
                        <td colspan="4">
                          <div class="files-detail">
                            <div class="files-section">
                              <h6>Da Importare:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.to_import" :key="file">{{ file }}</div>
                                <div v-if="monthData.to_import.length === 0" class="no-files">Nessun file da importare
                                </div>
                              </div>
                            </div>
                            <div class="files-section">
                              <h6>Importati:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.imported" :key="file">{{ file }}</div>
                                <div v-if="monthData.imported.length === 0" class="no-files">Nessun file importato</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="text-center">Nessun dato disponibile</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              
              <div class="status-table-container">
                <h5>RCU Gas UD</h5>
                <table class="file-table">
                  <thead>
                    <tr>
                      <th>Mese</th>
                      <th>Da Importare</th>
                      <th>Importati</th>
                      <th>Totale Files</th>
                    </tr>
                  </thead>
                  <tbody v-if="importStatus && importStatus.data && importStatus.data.gas_ud && importStatus.data.gas_ud.months">
                    <template v-for="monthData in importStatus.data.gas_ud.months" :key="monthData.month">

                      <tr class="month-row" @click="toggleMonth('gas_ud', monthData.month)">
                        <td>
                          <i
                            :class="['fas', expandedMonths[`gas_ud-${monthData.month}`] ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
                          {{ monthData.month }}
                        </td>
                        <td>{{ monthData.to_import.length }}</td>
                        <td>{{ monthData.imported.length }}</td>
                        <td>{{ monthData.to_import.length + monthData.imported.length }}</td>
                      </tr>

                      <tr v-if="expandedMonths[`gas_ud-${monthData.month}`]" class="detail-row">
                        <td colspan="4">
                          <div class="files-detail">
                            <div class="files-section">
                              <h6>Da Importare:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.to_import" :key="file">{{ file }}</div>
                                <div v-if="monthData.to_import.length === 0" class="no-files">Nessun file da importare
                                </div>
                              </div>
                            </div>
                            <div class="files-section">
                              <h6>Importati:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.imported" :key="file">{{ file }}</div>
                                <div v-if="monthData.imported.length === 0" class="no-files">Nessun file importato</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="text-center">Nessun dato disponibile</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-for="(categoryData, category) in importStatus.data.energia" :key="category"
                class="status-table-container">
                <h5>RCU Energia Elettrica - {{ category }}</h5>
                <table class="file-table">
                  <thead>
                    <tr>
                      <th>Mese</th>
                      <th>Da Importare</th>
                      <th>Importati</th>
                      <th>Totale Files</th>
                    </tr>
                  </thead>
                  <tbody v-if="categoryData.months.length > 0">
                    <template v-for="monthData in categoryData.months" :key="monthData.month">
                      <tr class="month-row" @click="toggleMonth('energia-' + category, monthData.month)">
                        <td>{{ monthData.month }}</td>
                        <td>{{ monthData.to_import.length }}</td>
                        <td>{{ monthData.imported.length }}</td>
                        <td>{{ monthData.to_import.length + monthData.imported.length }}</td>
                      </tr>
                      <tr v-if="expandedMonths[`energia-${category}-${monthData.month}`]" class="detail-row">
                        <td colspan="4">
                          <div class="files-detail">
                            <div class="files-section">
                              <h6>Da Importare:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.to_import" :key="file">{{ file }}</div>
                                <div v-if="monthData.to_import.length === 0" class="no-files">Nessun file da importare
                                </div>
                              </div>
                            </div>
                            <div class="files-section">
                              <h6>Importati:</h6>
                              <div class="file-list">
                                <div v-for="file in monthData.imported" :key="file">{{ file }}</div>
                                <div v-if="monthData.imported.length === 0" class="no-files">Nessun file importato</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="text-center">Nessun dato disponibile</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="text-center">
              <p>Caricamento dati in corso...</p>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import moment from "moment";
import Calendar from 'primevue/calendar';

export default {
  components: {
    Loader,
    DataTable,
    Column,
    Calendar,
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const fileToUpload = ref([]);
    const currentUser = ref(store.state.auth.user);
    const allowedType = ["zip", "x-zip-compressed"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const selectedDestination = ref("");
    const paths = ref(["DF", "DT"]);
    const uploadedFiles = ref([]);
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const energyFileToUpload = ref([]);
    const selectedEnergyDestination = ref("");
    const energyPaths = ref(["EE", "GAS"]);
    const energyValidationErrors = ref({});
    const energySubmitted = ref(false);
    const selectedDate = ref(new Date());
    const importStatus = ref(null);
    const expandedMonths = ref({});

    const filteredFiles = computed(() => {
      return uploadedFiles.value.filter((file) => {
        return file.file_name
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase());
      });
    });

    const paginatedFiles = computed(() => {
      const startIndex = (currentPage.value - 1) * filesPerPage.value;
      const endIndex = startIndex + filesPerPage.value;
      return filteredFiles.value.slice(startIndex, endIndex);
    });

    const handleFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      fileToUpload.value = self.refs.file.files;
    };

    const resetForm = () => {
      fileToUpload.value = [];
      selectedDestination.value = "";
      self.refs.file.value = null;
    };

    const fetchUploadedFiles = async () => {
      loading.value = true;
      try {
        const response = await service.getUploadedFiles();
        uploadedFiles.value = response.files.map((file) => ({
          ...file,
          created_at: moment(file.upload_date).format("YYYY-MM-DD HH:mm:ss"),
        }));
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dello storico dei file caricati",
        });
      } finally {
        loading.value = false;
      }
    };

    const uploadFileRcuOnFtpAndDB = () => {
      submitted.value = true;
      if (validateForm()) {
        loading.value = true;
        const formData = new FormData();
        for (let file of fileToUpload.value) {
          formData.append('files[]', file);
        }
        formData.append('email', currentUser.value.email);
        formData.append('destination', selectedDestination.value);

        service
          .uploadFileRcuOnFtpAndDB(formData)
          .then((response) => {
            const message = response.message || "File Caricati con successo";
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: message,
              life: 5000,
            });
            resetForm();
            fetchUploadedFiles();
          })
          .catch((error) => {
            console.error("Errore durante il caricamento dei file:", error);
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante il caricamento dei file",
            });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const validateForm = () => {
      if (fileToUpload.value.length == 0) {
        validationErrors.value["files"] = true;
        delete validationErrors.value["type"];
      } else {
        delete validationErrors.value["files"];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(
          (file) => allowedType.includes(file.type.replace(/(.*)\//g, "")),
          false
        );
        if (valid) delete validationErrors.value["type"];
        else validationErrors.value["type"] = true;
      }

      return !Object.keys(validationErrors.value).length;
    };

    const handleEnergyFileUpload = (evt) => {
      evt.preventDefault();
      energySubmitted.value = false;
      energyFileToUpload.value = self.refs.energyFile.files;
    };

    const uploadEnergyFileRcu = () => {
      energySubmitted.value = true;
      if (validateEnergyForm()) {
        loading.value = true;
        const formData = new FormData();
        for (let file of energyFileToUpload.value) {
          formData.append('files[]', file);
        }
        formData.append('email', currentUser.value.email);
        formData.append('subdirectory', selectedEnergyDestination.value);

        service
          .uploadRcuDatiEnergia(formData)
          .then((response) => {
            const message = response.message || "File Caricati con successo";
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: message,
              life: 5000,
            });
            resetEnergyForm();
          })
          .catch((error) => {
            console.error("Errore durante il caricamento dei file:", error);
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante il caricamento dei file",
            });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const validateEnergyForm = () => {
      energyValidationErrors.value = {};

      if (energyFileToUpload.value.length == 0) {
        energyValidationErrors.value["files"] = true;
      }

      if (energyFileToUpload.value.length > 0) {
        let valid = [...energyFileToUpload.value].every(
          (file) => allowedType.includes(file.type.replace(/(.*)\//g, "")),
          false
        );
        if (!valid) energyValidationErrors.value["type"] = true;
      }

      return !Object.keys(energyValidationErrors.value).length;
    };

    const resetEnergyForm = () => {
      energyFileToUpload.value = [];
      selectedEnergyDestination.value = "";
      self.refs.energyFile.value = null;
      energySubmitted.value = false;
    };

    const importRcuGasData = async () => {
      if (!selectedDate.value) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Seleziona un mese di riferimento",
          life: 3000,
        });
        return;
      }

      const formattedDate = moment(selectedDate.value).format('YYYY-MM');

      loading.value = true;
      try {
        const response = await service.importRcuGasData(formattedDate);
        toast.add({
          severity: "success",
          summary: "Successo",
          detail: `Importazione completata. Righe importate: ${response.imported_rows}`,
          life: 5000,
        });

        if (response.errors && response.errors.length > 0) {
          response.errors.forEach(error => {
            toast.add({
              severity: "warn",
              summary: `Errore file: ${error.file}`,
              detail: error.error,
              life: 5000,
            });
          });
        }
      } catch (error) {
        console.error("Errore durante l'importazione:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'importazione dei dati",
          life: 5000,
        });
      } finally {
        loading.value = false;
      }
    };

    const importRcuEEData = async () => {
      if (!selectedDate.value) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Seleziona un mese di riferimento",
          life: 3000,
        });
        return;
      }

      const formattedDate = moment(selectedDate.value).format('YYYY-MM');

      loading.value = true;
      try {
        const response = await service.importRcuEEData(formattedDate);
        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Importazione completata con successo",
          life: 5000,
        });

        Object.entries(response.results).forEach(([category, result]) => {
          if (result.status === 'success') {
            toast.add({
              severity: "info",
              summary: `Categoria ${category}`,
              detail: `Righe importate: ${result.imported_rows}`,
              life: 5000,
            });
          } else {
            toast.add({
              severity: "warn",
              summary: `Categoria ${category}`,
              detail: result.message,
              life: 5000,
            });
          }

          if (result.errors && result.errors.length > 0) {
            result.errors.forEach(error => {
              toast.add({
                severity: "warn",
                summary: `Errore file ${category}: ${error.file}`,
                detail: error.error,
                life: 5000,
              });
            });
          }
        });
      } catch (error) {
        console.error("Errore durante l'importazione:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'importazione dei dati",
          life: 5000,
        });
      } finally {
        loading.value = false;
      }
    };

    const fetchImportStatus = async () => {
      try {
        const response = await service.getImportStatusCheckRcuDati();
        importStatus.value = response;
      } catch (error) {
        console.error("Errore durante il recupero dello stato di importazione:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dello stato di importazione",
          life: 3000,
        });
      }
    };

    const toggleMonth = (category, month) => {
      const key = `${category}-${month}`;
      expandedMonths.value[key] = !expandedMonths.value[key];
    };

    onMounted(() => {
      fetchUploadedFiles();
      fetchImportStatus();
    });

    return {
      store,
      validationErrors,
      submitted,
      fileToUpload,
      handleFileUpload,
      allowedType,
      uploadFileRcuOnFtpAndDB,
      loading,
      selectedDestination,
      paths,
      uploadedFiles,
      searchQuery,
      filteredFiles,
      paginatedFiles,
      currentPage,
      filesPerPage,
      energyFileToUpload,
      selectedEnergyDestination,
      energyPaths,
      energyValidationErrors,
      energySubmitted,
      handleEnergyFileUpload,
      uploadEnergyFileRcu,
      selectedDate,
      importRcuGasData,
      importRcuEEData,
      importStatus,
      expandedMonths,
      toggleMonth,
    };
  },
};
</script>

<style scoped>
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050,
    5px 5px 15px 5px rgba(0, 0, 0, 0);
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0, 0, 0, 0);
}

#upload,
#uploadEnergy {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  font-size: 0;
}

.history-card {
  margin-top: 20px;
}

.history-header {
  font-size: 20px;
  text-align: center;
}

.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.file-table th {
  background: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  font-weight: bold;
  color: white;
}

.file-count-select {
  display: flex;
}

.file-count-select option {
  margin-right: 10px;
}

.file-count-select-wrapper {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  border-radius: 20px;
}

.file-search-input {
  margin-top: 5px;
  margin-bottom: 10px;
  width: 10%;
  padding: 8px;
  border: 1px solid #000000;
  border-radius: 5px;
  box-sizing: border-box;
}

.dropdown-wrapper {
  margin-bottom: 10px;
  text-align: center;
}

.dropdown-wrapper label {
  margin-right: 10px;
}

.custom-dropdown {
  padding: 10px;
  width: 150px;
  border: 1px solid #000;
  border-radius: 3px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23000' stroke-width='2' d='M4 6l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

.custom-dropdown:hover {
  border-color: #04ba2e;
}

.import-section {
  border-top: 1px solid #ddd;
  padding-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.date-selector-row {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.date-selector-row label {
  white-space: nowrap;
  margin-right: 15px;
  font-weight: bold;
  min-width: 160px;
  color: #333;
}

.date-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-calendar {
  flex: 1;
  max-width: 300px;
}

.custom-calendar {
  width: 200px;
}
::deep(.p-calendar .p-button) {
    background: red !important;
    margin-left:10px;
    border: 1px solid #04ba2e;
}
:deep(.p-calendar) {
  width: 100%;
}

:deep(.p-calendar .p-inputtext) {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
}

:deep(.p-calendar .p-button) {
  background: #04ba2e;
  border: 1px solid #04ba2e;
}

:deep(.p-calendar .p-button:hover) {
  background: #038f23;
  border: 1px solid #038f23;
}

:deep(.month-picker-panel) {
  .p-datepicker-header {
    background: #04ba2e;
    color: white;
  }

  .p-datepicker-month {
    color: #333;
    font-weight: bold;
  }

  .p-highlight {
    background: #04ba2e !important;
    color: white !important;
  }
}

.import-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
}

.import-status-section {
  margin-top: 30px;
  width: 100%;
}

.status-tables {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.status-table-container {
  min-width: 300px;
}

.status-table-container h5 {
  text-align: center;
  margin-bottom: 10px;
  color: #333;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.status-table th,
.status-table td {
  padding: 12px;
  text-align: center;
  border: 1px solid #ddd;
}

.status-table th {
  background-color: #04ba2e;
  color: white;
  font-weight: bold;
}

.status-table tr:nth-child(even) {
  background-color: #f8f8f8;
}

.status-table tr:hover {
  background-color: #f0f0f0;
}

.file-list {
  max-height: 200px;
  overflow-y: auto;
  font-size: 0.9em;
  text-align: left;
  padding: 5px;
}

.file-list div {
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.status-table th,
.status-table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
}

.status-table th {
  background-color: #04ba2e;
  color: white;
}

.status-table td:nth-child(2) {
  text-align: center;
}

.status-table-container {
  margin-bottom: 30px;
  width: 100%;
}

.status-table-container h5 {
  margin-bottom: 10px;
  color: #333;
  font-size: 1.1em;
}

.month-section {
  margin-bottom: 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f8f9fa;
}

.month-header {
  background-color: #04ba2e;
  color: white;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 15px;
  text-align: center;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-table th,
.status-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.status-table th {
  background-color: #04ba2e;
  color: white;
}

.file-list {
  max-height: 150px;
  overflow-y: auto;
  font-size: 0.9em;
  padding: 5px;
}

.file-list div {
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-row {
  background-color: #e9ecef;
  font-weight: bold;
}

.status-table-container {
  margin-bottom: 40px;
}

.status-table-container h5 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-size: 1.2em;
  font-weight: bold;
}

.no-data-message {
  margin: 20px 0;
}

.no-data-message td {
  padding: 20px !important;
  color: #666;
  font-style: italic;
}

.text-center {
  text-align: center;
}

@media (max-width: 768px) {
  .file-list {
    max-height: 100px;
  }

  .status-table th,
  .status-table td {
    padding: 5px;
    font-size: 0.9em;
  }
}

.month-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.month-row:hover {
  background-color: #f5f5f5;
}

.month-row i {
  margin-right: 8px;
}

.detail-row {
  background-color: #f8f9fa;
}

.files-detail {
  padding: 15px;
  display: flex;
  gap: 20px;
}

.files-section {
  flex: 1;
}

.files-section h6 {
  margin-bottom: 10px;
  color: #04ba2e;
}

.file-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.file-list div {
  margin-bottom: 5px;
  font-size: 0.9em;
}

.no-files {
  color: #666;
  font-style: italic;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-table th,
.status-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.status-table th {
  background-color: #04ba2e;
  color: white;
}

.status-table-container {
  margin-bottom: 30px;
}

.status-table-container h5 {
  text-align: center;
  margin-bottom: 15px;
  color: #333;
}

@media (max-width: 768px) {
  .files-detail {
    flex-direction: column;
  }

  .file-list {
    max-height: 150px;
  }
}
</style>
